import React from 'react';
import styled, { css } from '../../styled';
import { Controller } from '../icons/solid';
const SortableHeadWrapper = styled.div `
  display: flex;
  align-items: center;
  padding: 0.75rem 0.5rem;
`;
const IconContainer = styled.div `
  ${({ theme, sorting, hasAscend, hasDescend }) => css `
    position: relative;
    height: 1.25rem;
    width: 1.25rem;
    svg {
      position: absolute;
    }
    svg:first-of-type {
      display: ${hasAscend ? 'block' : 'none'};
      top: ${hasDescend ? '-0.25rem' : '0'};
      path {
        fill: ${sorting === 'asc'
    ? theme.colors.PRIMARY_600
    : theme.colors.INK_400};
      }
    }
    svg:last-of-type {
      display: ${hasDescend ? 'block' : 'none'};
      bottom: ${hasAscend ? '-0.25rem' : '0'};
      path {
        fill: ${sorting === 'desc'
    ? theme.colors.PRIMARY_600
    : theme.colors.INK_400};
      }
    }
  `}
`;
const SortableHead = ({ column, onClickSortColumn, }) => {
    return (React.createElement(SortableHeadWrapper, { onClick: onClickSortColumn && (() => onClickSortColumn(column.key)) },
        React.createElement("span", null, column.title),
        React.createElement(IconContainer, { sorting: column.sorting, hasAscend: column.sortOption && ['asc', 'both'].includes(column.sortOption), hasDescend: column.sortOption && ['desc', 'both'].includes(column.sortOption) },
            React.createElement(Controller, { size: "MEDIUM", position: "TOP" }),
            React.createElement(Controller, { size: "MEDIUM", position: "BOTTOM" }))));
};
export default React.memo(SortableHead);
//# sourceMappingURL=SortableHead.js.map